export default `<div class=""><p class="successTitle">Your account has been successfully registered. <br> Top up your account and get bonuses!<br></p>
<style>.successTitle { text-align: center;  color: #140474; font-weight: bold; text-transform: none; margin-bottom: 30px; font-size: 20px;}</style></div>`;
